import React from 'react';
import { useTranslation } from 'react-i18next';

export function ColorConfig({ obj, handleColor, dataName, paddingTopZero }) {
  const { t } = useTranslation('common');
  return (
    <div className={`${paddingTopZero ? 'py-0' : 'py-3'} pl-0 pr-2`}>
      <p className="mb-2 f-14 text-bold">{t('CUSTOM_MODULE.COLOR')}</p>
      <div className="border-color-container">
        <input className="cursor-pointer" type="color" id="color" onChange={handleColor} value={obj?.otherConfiguration?.[dataName]} name={dataName} />
      </div>
    </div>
  );
}

export default ColorConfig;
